// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__7JFDF","header":"MergedInvoice_header__3x9ap"};